import React from 'react';
import ColorCrafterLegalDocumentPage from './ColorCrafterLegalDocumentPage';

const PrivacyPolicyPage: React.FC = () => <ColorCrafterLegalDocumentPage kind="privacy" />;

export default PrivacyPolicyPage;
